


















import { Component, Vue, Watch } from 'vue-property-decorator';
import { Route } from 'node_modules/vue-router/types';
import { getUserLogworks } from '@/services/api.service';
import { ILogworkData, ILogworkWithProject, IUser } from '@/lib/interfaces';
import { ruMonth } from '@/lib/helpers/common.helper';
import store from '@/store';

@Component
export default class UserLogworks extends Vue {
  private year: number = new Date().getFullYear();
  private month: number = new Date().getMonth();
  private ruMonth = ruMonth;
  private data: {
    projectGroup: ILogworkWithProject[];
    dateGroup: ILogworkData[];
  } | null = null;

  private user: IUser = {} as IUser;

  private getUser(userId): IUser {
    return this.$store.state.users[userId];
  }

  private async updateData() {
    if (this.user) {
      this.data = await getUserLogworks({
        month: this.month + 1,
        year: this.year,
        user_id: this.user._id,
      });
    }
  }

  /** Года, которые начинаются со старта работы */
  private get years(): number[] {
    const res: number[] = [];
    const startWorkDate = new Date(this.$store.state.currentUser.start_work_date);
    for (let year = startWorkDate.getFullYear(); year <= new Date().getFullYear(); year++) {
      res.push(year);
    }
    return res;
  }

  private async beforeRouteEnter(to: Route, from: Route, next: (vm?: any) => void) {
    const curDate = new Date();
    const userId = to.params.user_id;

    const data = await getUserLogworks({
      month: curDate.getMonth() + 1,
      year: curDate.getFullYear(),
      user_id: userId,
    });
    next((vm: UserLogworks) => {
      vm.user = vm.getUser(userId);
      vm.data = data;
    });
  }
}
